export function buildPasswordResetRedirectTo(currentHref: string): string {
  const url = new URL(currentHref)
  url.pathname = '/reset-password'
  url.search = ''
  url.hash = ''
  return url.toString()
}

export function validateNewPassword(password: string, confirmPassword: string): string | null {
  if (!password) return '新しいパスワードを入力してください。'
  if (password.length < 8) return 'パスワードは8文字以上で入力してください。'
  if (password !== confirmPassword) return '確認用パスワードが一致しません。'
  return null
}
